import { removeFromJobQueue } from "slices/app/appSlice";
import { removeErrorMessage } from "slices/app/errorSlice";
import { addModal, removeModal } from "slices/app/modalsSlice";

export const showModal = (modalType, modalProps) => (dispatch) => {
  dispatch(addModal({ modalType, modalProps }));
};

export const hideModal = (modalType) => (dispatch) => {
  dispatch(removeModal({ modalType }));
  dispatch(removeErrorMessage());
  dispatch(removeFromJobQueue("genericJob"));
};
